import React, { useEffect, useState } from "react";
import {
  Box, Button, Flex, Table, Tbody, Td, Th, Thead, Tr, Text, useToast, Spinner, Badge,
  Select, Heading,
} from "@chakra-ui/react";
import { getIntros, updateIntroStatus } from "../../utils/apis/agentApi";

const STATUSES = ["sent", "contacted", "job_done", "no_show", "cancelled", "not_used", "unknown"];
const COLOR: Record<string, string> = {
  sent: "gray", contacted: "blue", job_done: "green", no_show: "red",
  cancelled: "orange", not_used: "purple", unknown: "gray",
};

/** Agent intros: every customer↔provider introduction, with a status override
 *  (feeds ranking + follow-ups). */
const Intros = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const load = async () => {
    setLoading(true);
    const res = await getIntros(200);
    if (res.ok && Array.isArray(res.data)) setRows(res.data);
    else toast({ title: res.status === 502 ? "Agent unreachable" : "Failed to load",
      status: "error", duration: 3000, isClosable: true });
    setLoading(false);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const setStatus = async (id: string, status: string) => {
    const res = await updateIntroStatus(id, status);
    if (res.ok) { toast({ title: "Updated", status: "success", duration: 1500 }); load(); }
    else toast({ title: "Failed", status: "error", duration: 3000 });
  };

  return (
    <Box p={5}>
      <Flex justifyContent="space-between" mb={4}>
        <Heading size="md">Intros</Heading>
        <Button colorScheme="purple" backgroundColor="#88077b" onClick={load}>Refresh</Button>
      </Flex>
      {loading ? <Spinner size="xl" /> : rows.length === 0 ? (
        <Text color="admin.muted">No intros.</Text>
      ) : (
        <Table variant="striped" size="sm">
          <Thead backgroundColor="#88077b"><Tr>
            <Th color="white">When</Th><Th color="white">Customer</Th><Th color="white">Worker</Th>
            <Th color="white">Trade</Th><Th color="white">Area</Th><Th color="white">Status</Th>
          </Tr></Thead>
          <Tbody>
            {rows.map((r, i) => (
              <Tr key={r.id} backgroundColor={i % 2 === 0 ? "admin.surface" : "admin.selected"}>
                <Td whiteSpace="nowrap">{r.created_at ? new Date(r.created_at).toLocaleString() : "-"}</Td>
                <Td>{r.customer_phone}</Td>
                <Td>{r.worker_name || r.provider_id}</Td>
                <Td>{r.category || "-"}</Td>
                <Td>{r.area || "-"}</Td>
                <Td>
                  <Flex align="center" gap={2}>
                    <Badge colorScheme={COLOR[r.status] || "gray"}>{r.status}</Badge>
                    <Select size="xs" w="130px" value={r.status} onChange={(e) => setStatus(r.id, e.target.value)}>
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </Select>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};
export default Intros;
